import axios from 'axios'
import {
  POSTS_REQUEST, POSTS_SUCCESS, POSTS_FAIL,
  LATEST_POSTS_REQUEST, LATEST_POSTS_SUCCESS, LATEST_POSTS_FAIL,
  POST_REQUEST, POST_SUCCESS, POST_FAIL,
  COMMENT_REQUEST, COMMENT_SUCCESS, COMMENT_FAIL,
  READ_LATER_ADD, READ_LATER_REMOVE,
  SUBSCRIBE_REQUEST, SUBSCRIBE_SUCCESS, SUBSCRIBE_FAIL, SUBSCRIBE_RESET,
  UNSUBSCRIBE_REQUEST, UNSUBSCRIBE_SUCCESS, UNSUBSCRIBE_FAIL,
} from '../constants/blogConstants'

export const getPosts = () => async (dispatch) => {
  try {
    dispatch({ type: POSTS_REQUEST })
    const { data } = await axios.get('/api/blog/posts/')
    dispatch({ type: POSTS_SUCCESS, payload: data })
  } catch (e) {
    dispatch({ type: POSTS_FAIL, payload: e.response?.data?.detail ?? e.message })
  }
}

export const getLatestPosts = () => async (dispatch) => {
  try {
    dispatch({ type: LATEST_POSTS_REQUEST })
    const { data } = await axios.get('/api/blog/posts/latest/')
    dispatch({ type: LATEST_POSTS_SUCCESS, payload: data })
  } catch (e) {
    dispatch({ type: LATEST_POSTS_FAIL, payload: e.response?.data?.detail ?? e.message })
  }
}

export const getPost = (slug) => async (dispatch) => {
  try {
    dispatch({ type: POST_REQUEST })
    const { data } = await axios.get(`/api/blog/posts/${slug}/`)
    dispatch({ type: POST_SUCCESS, payload: data })
  } catch (e) {
    dispatch({ type: POST_FAIL, payload: e.response?.data?.detail ?? e.message })
  }
}

export const addComment = (slug, commentData) => async (dispatch) => {
  try {
    dispatch({ type: COMMENT_REQUEST })
    await axios.post(`/api/blog/posts/${slug}/comments/`, commentData)
    dispatch({ type: COMMENT_SUCCESS })
  } catch (e) {
    dispatch({ type: COMMENT_FAIL, payload: e.response?.data?.detail ?? e.message })
  }
}

export const toggleReadLater = (postId) => (dispatch, getState) => {
  const { ids } = getState().rootReducer.readLaterRed
  if (ids.includes(postId)) {
    dispatch({ type: READ_LATER_REMOVE, payload: postId })
  } else {
    dispatch({ type: READ_LATER_ADD, payload: postId })
  }
}

export const subscribeBlog = (formData) => async (dispatch) => {
  try {
    dispatch({ type: SUBSCRIBE_REQUEST })
    await axios.post('/api/blog/subscribe/', formData)
    dispatch({ type: SUBSCRIBE_SUCCESS })
  } catch (e) {
    let msg = e.message
    const data = e.response?.data
    if (typeof data?.detail === 'string') {
      msg = data.detail
    } else if (data && typeof data === 'object') {
      const first = Object.values(data)[0]
      msg = Array.isArray(first) ? first[0] : String(first)
    }
    dispatch({ type: SUBSCRIBE_FAIL, payload: msg })
  }
}

export const resetSubscribe = () => (dispatch) => dispatch({ type: SUBSCRIBE_RESET })

export const unsubscribeBlog = (token) => async (dispatch) => {
  try {
    dispatch({ type: UNSUBSCRIBE_REQUEST })
    await axios.post(`/api/blog/unsubscribe/${token}/`)
    dispatch({ type: UNSUBSCRIBE_SUCCESS })
  } catch (e) {
    dispatch({ type: UNSUBSCRIBE_FAIL, payload: e.response?.data?.detail ?? e.message })
  }
}
